import { render, staticRenderFns } from "./TheProductsSearchFooter.vue?vue&type=template&id=dbd43d7c&scoped=true&"
import script from "./TheProductsSearchFooter.vue?vue&type=script&lang=js&"
export * from "./TheProductsSearchFooter.vue?vue&type=script&lang=js&"
import style0 from "./TheProductsSearchFooter.vue?vue&type=style&index=0&id=dbd43d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd43d7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Server\\domains\\localhost\\ss\\wa-apps\\shop\\plugins\\giftcertificates\\build\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbd43d7c')) {
      api.createRecord('dbd43d7c', component.options)
    } else {
      api.reload('dbd43d7c', component.options)
    }
    module.hot.accept("./TheProductsSearchFooter.vue?vue&type=template&id=dbd43d7c&scoped=true&", function () {
      api.rerender('dbd43d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/pages/marketing_item/TheProductsSearchFooter.vue"
export default component.exports